import logo from '../../assets/img/img_logo/logo.png'
import brandNameLogo from '../../assets/img/img_logo/brandNameLogo.svg'

export default {
    logo, brandNameLogo
}